import React from "react";
import HeadLines from "./HeadLines";
import style from "./style.module.css";
const DotComponent = ({ firstPart, secondPart, className }) => {
  return (
    <div className={className[0]}>
      <HeadLines text={firstPart} className={className[1]} />
      {secondPart ? (
        <>
          <HeadLines text="" className={`${style["dotCSS"]} ${className[2]}`} />
          <HeadLines text={secondPart} className={className[3]} />
        </>
      ) : (
        ""
      )}
    </div>
  );
};
export default DotComponent;
